class HttpError extends Error {
  constructor(httpCode, body, correlationId, ...params) {
    super(...params);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HttpError);
    }

    this.httpCode = httpCode;
    this.body = body;
    this.correlationId = correlationId;
  }
}

export default HttpError;